'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Created by yanghuan on 17/5/30.
                                                                                                                                                                                                                                                                   */

var _getPageByServiceId = require('./getPageByServiceId');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @param {Object} fetchResult
 * @returns {Object}
 */
var passData = exports.passData = function passData(fetchResult) {
  var validFetchResult = fetchResult || {};

  var _getPageDataAndAttr = (0, _getPageByServiceId.getPageDataAndAttr)(_extends({}, validFetchResult)),
      data = _getPageDataAndAttr.data,
      pageAttr = _getPageDataAndAttr.pageAttr;

  return _extends({}, validFetchResult, { data: data, pageAttr: pageAttr });
};

exports.default = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(fetch, url, id) {
    var fetchResult;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch({ url: url, data: { id: id } });

          case 2:
            fetchResult = _context.sent;
            return _context.abrupt('return', passData(fetchResult));

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/api/getPageByQueryInfo.js
// module id = 214
// module chunks = 0